var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatelessnessChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 113,
    viewBox: "0 0 132 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.78326,
    width: 9.46306,
    height: 107.58,
    rx: 4.73153,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.02,
    y: 99.0837,
    width: 9.46306,
    height: 120.236,
    rx: 4.73153,
    transform: "rotate(90 123.02 99.0837)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 5.56641,
    width: 9.46306,
    height: 107.434,
    rx: 4.73153,
    fill: "#EAECF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.237,
    y: 103.537,
    width: 9.46306,
    height: 120.236,
    rx: 4.73153,
    transform: "rotate(90 120.237 103.537)",
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8226 85.1089L48.1502 57.7158L72.6262 61.8814L107.99 25.5912",
    stroke: "#CBCBCB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.606 86.7534L50.9335 59.3604L75.4095 63.5259L110.773 27.2358",
    stroke: "#EAECF0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.541 12.7417C117.873 12.3729 119.189 13.2373 119.195 14.4849L119.225 20.5709C119.235 22.5789 116.234 23.3061 115.247 21.5349L114.142 19.5528C113.85 19.029 113.299 18.667 112.653 18.5748L110.208 18.226C108.023 17.9143 107.899 15.1344 110.043 14.5408L116.541 12.7417Z",
    fill: "#CBCBCB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.876 13.8618C121.208 13.493 122.524 14.3574 122.53 15.6051L122.56 21.691C122.57 23.699 119.569 24.4262 118.581 22.655L117.477 20.6729C117.185 20.1491 116.633 19.7871 115.987 19.6949L113.543 19.3461C111.358 19.0344 111.234 16.2545 113.378 15.6609L119.876 13.8618Z",
    fill: "#EAECF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatelessnessChart);
export default __webpack_public_path__ + "static/media/statelessness-chart.880dbe10c24e63bb9972c74d55890533.svg";
export { ForwardRef as ReactComponent };